import $ from 'jquery';
import { useEffect, useState } from 'react';
import axios from 'axios';
import useApiUrl from '../../framework/hooks/useApiUrlHook';

export default function CaseBoxes({ cases = [] }) {
    const apiUrl = useApiUrl();
    if (cases.length > 0) {
        return (
            <>
                <div className="row">
                    <div className="col-xl-12">
                        <div
                            className="e-feature-content"
                            data-aos="fade-up"
                            data-aos-duration={1000}
                        >
                            <h2>Hier heb ik aan meegewerkt</h2>
                            <h3>Recente projecten</h3>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {cases?.map((c) => (
                        <div className="col-xl-4 col-md-6 mt-4">
                            <a
                                className="e-feature-thumb caseBox d-flex flex-column justify-content-center align-items-center"
                                data-aos="fade-up"
                                data-aos-delay={300}
                                data-aos-duration={1000}
                                style={{
                                    backgroundImage: `url(${apiUrl}/img/extern/ratio/www.bandwerk.nl/klanten_sfeer/orig/1805/1805/100/${c.image})`,
                                }}
                                href={`/succesverhalen/${c.fancy_name}`}
                            >
                                <h3>{c.bedrijfsnaam}</h3>
                            </a>
                        </div>
                    ))}
                </div>
            </>
        );
    } else {
        return (
            <div></div>
        );
    }
}
